import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000A14",
		fillRule: "evenodd",
		d: "M15.707 5.293c-.36-.36-.928-.388-1.32-.083l-.094.083-6 6c-.36.36-.388.928-.083 1.32l.083.094 6 6c.39.39 1.024.39 1.414 0 .36-.36.388-.928.083-1.32l-.083-.094L10.415 12l5.292-5.293c.36-.36.388-.928.083-1.32l-.083-.094z"
	})
});
export default SvgIcArrowLeft;
